// src/jira/entitlement/types.ts
var JiraEntitlementAriResourceOwner = "jira", JiraEntitlementAriResourceType = "entitlement";

export {
  JiraEntitlementAriResourceOwner,
  JiraEntitlementAriResourceType
};
